<div class="viewport-1" [style.background-image]="'url(' + interventionTaskService.taskBackgroundImage() + ')'">
  <student-header></student-header>
  <task-bar #taskBar [totalPoints]="taskTotalPoints"></task-bar>

  <div class="task-screen-element fill-in-blank-container"
    [style.background-image]="' ' + interventionTaskService.taskContainerColor() + ' '"
    [class]="(animationComplete || !animateContainer) ? 'taskShow' : 'taskHide'">
    @if (!isUnit) {
      <div class="testType font-18">{{interventionTaskService.testType()}}</div>
    }
    <div class="timer-bar-container">
      <trial-timer-bar></trial-timer-bar>
      <button [class]="(hideTimer) ? 'replayVideo-no-timerbar' : 'replayVideo'" (click)="replayVideo()"
      [disabled]="disableAVButtons"></button>
    </div>
    <div [class]="(isUnit) ? 'target-area-ftb-unit' : 'word-to-complete'">
      <!-- tiles that spell the incomplete word will go in here
      Probably use ng-repeat to loop over letters in the target word-->
      <div class="audio-controls-container find-the-syllables-speaker-position">
        <button class="speaker" (click)="playTargetAudioViaSpeakerClick()" [disabled]="disableAVButtons"></button>
        <button class="snail-button" (click)="playTargetAudioViaSpeakerClickSlowed()" [disabled]="disableAVButtons"></button>
      </div>
      @if (isUnit) {
        <div class="incorrect-row">
          @for (letter of incorrectTop; track $index) {
            <div class="target-incorrect unit-fill"
              style="left: 1.3%;"
              [class]="{ 'slash' : ($index===blankTile || $index===responseSilentEIndex), 'first-target-block-left-fill': (showTopRowSilentE) }"
              [hidden]="!showIncorrectTop">
              <div class="target-incorrect-text font-24">{{letter}}</div>
            </div>
          }
        </div>
      }
      @if (isUnit) {
        <div class="incorrect-row">
          @for (letter of incorrectBottom; track $index) {
            <div class="target-incorrect unit-fill"
              [class]="{ 'slash' : ($index===blankTile || $index===responseSilentEIndex), 'float-incorrect-top-up': (floatIncorrectUp && showIncorrectBottom), 'first-target-block-left-fill': (showBottomRowSilentE) }"
              [hidden]="!showIncorrectBottom">
              <div class="target-incorrect-text font-24">{{letter}}</div>
            </div>
          }
        </div>
      }
      <div [class]="{ 'target-row': isUnit, 'target-row-prepost': !isUnit }">
        @for (letter of targetWord; track $index) {
<div [class]="{'target-block' : isUnit, 'target-block-prepost' : !isUnit, 'first-target-block-left-fill' : (showTargetSilentE), 'prepost-fill': !isUnit, 'unit-fill': isUnit,
            'hover': (highlightCorrectResponse && ($index==blankTile || $index==targetSilentEIndex))}"
            [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '">
            @if (showIncorrectBottom) {
              <button class="fib" [class]="{'target-letter-audio' : showIncorrectBottom, 'target-letter-audio-hidden' : !showIncorrectBottom}"
              (click)="playTargetLetterAudio($index)" [disabled]="disableAVButtons"></button>
            }
            <button class="target-text font-30"
              [class]="{'slash-target': showTargetSlash && ($index===blankTile || $index===responseSilentEIndex), 'float-incorrect-up': floatIncorrectUp}">
              {{letter}}
            </button>
          </div>
        }
      </div>
    </div>
    <!-- response options on tiles will go in here (will need to separate into two sets for the different rows)
    Probably ng-repeat looping through the response options-->
    <div class="response-row">
      @for (response of responseOptions1; track $index) {
        <div class="button-div">
          @if (!showResponseAudioButtons) {
            <button class = "letter-audio-hidden"></button>
          }
          @if (showResponseAudioButtons) {
            <button class = "letter-audio" (click)="playLetterAudio($index)"
            [disabled]="disableAVButtons"></button>
          }
          <button #respButton1 class="font-30"
            [class]="{ 'hover': toggleHover($index), 'response-block-grayed': responsesDisabled,  'response-block': !responsesDisabled }"
            [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"
            [disabled]="responsesDisabled"
            (click)="submitResponse($index); removeHoverClass(respButton1);"
            (touchstart)="addHoverClass(respButton1)" (touchend)="removeHoverClass(respButton1)"
            (mousemove)="addHoverClass(respButton1)" (mouseenter)="addHoverClass(respButton1)" (mouseleave)="removeHoverClass(respButton1)">
            {{response}}
          </button>
          @if (silentTiles[$index]) {
            <button class="font-24"
              [class]="{ 'hover': toggleHover($index), 'silent-e-grayed': responsesDisabled, 'silent-e': !responsesDisabled }"
              [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"
              [disabled]="responsesDisabled"
              (click)="submitResponse($index); removeHoverClass(respButton1);"
              (touchstart)="addHoverClass(respButton1)" (touchend)="removeHoverClass(respButton1)"
              (mousemove)="addHoverClass(respButton1)" (mouseenter)="addHoverClass(respButton1)" (mouseleave)="removeHoverClass(respButton1)">
              e
            </button>
          }
          @if (!silentTiles[$index]) {
            <button class="silent-e-hidden"
            [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"></button>
          }
        </div>
      }
    </div>
    <div class="response-row">
      <!-- use $index + 4 so we can keep the index returned unique because $index resets when we start a new ng-repeat -->
      @for (response of responseOptions2; track $index) {
        <div class="button-div">
          @if (!showResponseAudioButtons) {
            <button class = "letter-audio-hidden"></button>
          }
          @if (showResponseAudioButtons) {
            <button class = "letter-audio" (click)="playLetterAudio($index+4)"
            [disabled]="disableAVButtons"></button>
          }
          <button #respButton2 class="font-30"
            [class]="{ 'hover': toggleHover($index + 4), 'response-block-grayed': responsesDisabled,  'response-block': !responsesDisabled }"
            [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"
            [disabled]="responsesDisabled"
            (click)="submitResponse($index+4); removeHoverClass(respButton2);"
            (touchstart)="addHoverClass(respButton2)" (touchend)="removeHoverClass(respButton2)"
            (mousemove)="addHoverClass(respButton2)" (mouseenter)="addHoverClass(respButton2)" (mouseleave)="removeHoverClass(respButton2)">
            {{response}}
          </button>
          @if (silentTiles[$index + 4]) {
            <button class="font-24"
              [class]="{ 'hover': toggleHover($index + 4), 'silent-e-grayed': responsesDisabled, 'silent-e': !responsesDisabled }"
              [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"
              [disabled]="responsesDisabled"
              (click)="submitResponse($index+4); removeHoverClass(respButton2);"
              (touchstart)="addHoverClass(respButton2)" (touchend)="removeHoverClass(respButton2)"
              (mousemove)="addHoverClass(respButton2)" (mouseenter)="addHoverClass(respButton2)" (mouseleave)="removeHoverClass(respButton2)">
              e
            </button>
          }
          @if (!silentTiles[$index + 4]) {
            <button class="silent-e-hidden"
            [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"></button>
          }
        </div>
      }
    </div>
  </div>
  @if (isDevMode) {
    <div>{{wordListAttempt}} - {{task.wordlistType}}</div>
  }

  <trial-counter [showCorrectIncorrect]="true" [taskAnimationComplete]="animationComplete"></trial-counter>
  <instructions [videoSource]="instructionalVideoFile"></instructions>
  <save-data-dialog (onSaveButtonClick)="saveTaskData()"></save-data-dialog>
  <focus-dialog></focus-dialog>
</div>
